<template>
  <cashier_nav />
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <!-- <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #visit id
      </th> -->
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Customer Identity
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        Time Created
      </th>
      <!-- <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Phone Contact
      </th> -->
      <!-- <th
                  class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                >
                  Gender
                </th> -->

      <th class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <!-- <td>#{{ user.visit_id }}</td> -->
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.name }}</h6>
              <!-- <p class="text-xs text-secondary mb-0">
                {{
                  user.email == null
                    ? user.name == null
                      ? "OTC_Client " + form_date(user.created_at)
                      : "--"
                    : user.email
                }}
              </p> -->
              <span v-if="user.pres_note != 'OTC Sale'">{{
                  user.pres_note
                }}</span>
                <span class="text-xs text-secondary mb-0" v-if="user.pres_note == 'OTC Sale'">{{
                  "OTC_" + form_date(user.created_at)
                }}</span>


            </div>
          </div>
        </td>
        <td>{{ form_date(user.created_at) }}</td>
        <!-- <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">{{
            user.phone == null ? "---" : user.phone
          }}</soft-badge>
        </td> -->
        <!-- <td class="align-middle text-center">
                    <span class="text-secondary text-xs font-weight-bold">{{
                      user.gender == null
                        ? "--"
                        : user.gender == 1
                        ? "Male"
                        : user.gender == 2
                        ? "Female"
                        : "Other"
                    }}</span>
                  </td> -->
        <td class="align-middle">
          <button
            @click="
              showPaymentModal(
                user.patient_id,
                user.visit_id,
                user.prescription_id
              )
            "
            style="
              border: 1px solid black;
              padding: 4px;
              color: green;
              font-weight: bold;
            "
            data-toggle="tooltip"
            data-original-title="Edit user"
          >
            View Bills
          </button>
        </td>
      </tr>
    </template>
  </BaseLayout>
  <BillModal
    v-if="showBillModal"
    :prescriptionID="prescription_id"
    :patientId="current_patient"
    :visitId="current_visit"
    @close-bill-modal="closePresMod"
  />
</template>

<script>
import cashier_nav from "./cashier_nav.vue";
// import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import BillModal from "./cashier_bill_pop.vue";
import BaseLayout from "../../Patients/components/table_page_layout.vue";
import formatDateTime from "../../../timezone/utc_local_time";

//import axios from "axios";

export default {
  name: "CashierWalkin",
  data() {
    return {
      current_patient: "",
      current_visit: "",
      users: [],
      // visit_id: this.$route.params.storeLocation,
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone..",
      searchUrl: "",
      mainUrl: "get_all_gp_cashier_queue_walkin",
      showBillModal: false,
      prescription_id: "",
    };
  },
  components: {
    BaseLayout,
    BillModal,
    cashier_nav,
  },

  methods: {
    form_date(dt) {
      return formatDateTime(dt);
    },
    handle_external_mount(payload) {
      this.users = payload;
      // console.log(payload);
    },
    showPaymentModal(patient, visit, prescription_id) {
    //   console.log(prescription_id);
      this.current_patient = patient;
      this.current_visit = visit;
      this.showBillModal = true;
      this.prescription_id = prescription_id;
    },
    closePresMod() {
      this.showBillModal = false;
      this.current_patient = "";
    },
  },

  mounted() {
    // console.log(this.users);

    // this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
